import { cn } from '@virginexperiencedays/tailwind';

import { DataTestId } from '.';

import type { HTMLAttributes } from 'react';

export const Price = ({ children, className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div
    data-testid={DataTestId.priceContainer}
    className={cn('flex flex-col items-start gap-1 md:gap-2 lg:flex-row', className)}
    {...rest}
  >
    {children}
  </div>
);

export const PriceCurrent = ({ children, className, ...rest }: HTMLAttributes<HTMLSpanElement>) => (
  <span
    data-testid={DataTestId.priceCurrent}
    className={cn(
      'text-neutral-strong text-[26px] font-bold leading-normal lg:text-3xl lg:leading-none',
      className
    )}
    {...rest}
  >
    {children}
  </span>
);

export const PriceBefore = ({ children, className, ...rest }: HTMLAttributes<HTMLSpanElement>) => (
  <span
    data-testid={DataTestId.pricePast}
    className={cn(
      'text-neutral-faded mr-1 text-sm font-[500] leading-normal line-through md:mr-0',
      className
    )}
    {...rest}
  >
    {children}
  </span>
);

export const PricePercentOff = ({
  children,
  className,
  ...rest
}: HTMLAttributes<HTMLSpanElement>) => (
  <span
    data-testid={DataTestId.priceSavings}
    className={cn(
      'rounded bg-white px-1 py-0.5 text-xs font-semibold uppercase leading-4 tracking-wide text-black',
      'bg-background-neutral-strong text-background-page',
      className
    )}
    {...rest}
  >
    {children}
  </span>
);
